import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./assets/css/responsive.css"

const appUrl = window.location.origin;
import VueLazyload from "vue-lazyload";
const theme = localStorage.getItem("theme");
var isDark = false;
if (theme) {
  isDark = theme == "dark";
}
const loader = isDark ? "/dark_loader.svg" : "/loader.svg";
const error = isDark ? "/dark_loader.svg" : "/loader.svg";
Vue.use(VueLazyload, {
  error: appUrl + error,
  loading: appUrl + loader,
});

import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";
import CoolLightBox from "vue-cool-lightbox";
Vue.use(CoolLightBox);
Vue.use(require('vue-moment'));

import Transitions from "vue2-transitions";
Vue.use(Transitions);

Vue.config.productionTip = false;
new Vue({
  router,

  created() {},
  render: (h) => h(App),
}).$mount("#app");
